<script>
export default {
  name: 'LucideIcon',
  functional: true,
  props: {
    icon: {
      type: Array,
      required: true
    },
    size: {
      type: [Number, String],
      default: 24
    },
    strokeWidth: {
      type: [Number, String],
      default: 2
    }
  },
  render(h, { props, data }) {
    const children = props.icon.map(([tag, attrs]) => h(tag, { attrs }))
    return h(
      'svg',
      {
        ...data,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          width: props.size,
          height: props.size,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': props.strokeWidth,
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          ...data.attrs
        }
      },
      children
    )
  }
}
</script>
